const e = () => typeof window > "u" ? !1 : "ontouchstart" in window;
export {
  e as isTouchScreenDevice
};
